import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

var store = new Vuex.Store({
  // 1. state
  state: {
    openId: localStorage['site_open_id_'+process.env.VUE_APP_NAME]?localStorage['site_open_id_'+process.env.VUE_APP_NAME]:'',
    // token:localStorage.getItem('token')
    ownerStates:localStorage.getItem("VUEX_OWNERCODE") || '',//车主信息状态 2001：没有信息去帮手机号 0：没有信息去新增 1：信息不全去提交资料 2：生成车主码
    ownerInfo:JSON.parse(localStorage.getItem("VUEX_OWNER")) || {},//车主信息
    storeVisit:{
        "inspect": {
            "openId": "",
            "userName": "",
            "phone": "",
            "dept": "",
            "location": "",
            "city": "",
            "dealerId": "",
            "dealerName": "",
            "storeId": "",
            "storeName": "",
            "storeCode": "",
            "type": "1",
            "startTime": "",
            "endTime": "",
            "picUrl": ""
        },
        "qsStore": {
            "popularModel": "",
            "popularConfig": "",
            "popularColor": "",
            "missingCategoryAndType": "",
            "qcProblem": "",
            "qcProblemPic": "",
            "otherProblem": "",
            "dealerCompanySuggestion": ""
        },
        "qsCity": {
            "limitMotor": "",
            "mustRegister": "",
            "registerStrict": "",
            "buyerGroup": "",
            "popularCategory": "",
            "popularSeries": "",
            "biggestCompetitor": "",
            "competitorSales": "",
            "competitorPopularSeries": "",
            "userCompanySuggestion": "",
            "personalStoreSuggestion": "",
            "personalCompanySuggestion": "",
            "experience": ""
        }
    },//门店走访提交数据
  },

  // 2. getters
  getters: {
    getOpenId: state => state.openId,
    // token:state => state.token,
  },

  // 3. actions
  actions: {
    // setOwnerInfo(state,val){
    //     localStorage.setItem('VUEX_OWNER',JSON.stringify(val))
    //     state.ownerInfo = val
    // },
    // setOwnerStates(state,val){
    //     localStorage.setItem('VUEX_OWNERCODE',val)
    //     state.ownerStates = val
    // }
  },

  // 4. mutations
  mutations: {
    getOpenId(state, item) {
      this.state.openId = item;
      let openidKey = 'site_open_id_'+process.env.VUE_APP_NAME
      localStorage[openidKey] = item;
      // localStorage.setItem('site_open_id',item)
    },

    setOwnerInfo(state,val){
        localStorage.setItem('VUEX_OWNER',JSON.stringify(val))
        state.ownerInfo = val
    },
    setOwnerStates(state,val){
        localStorage.setItem('VUEX_OWNERCODE',val)
        state.ownerStates = val
    }
  }
});

export default store
